import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

const SFPageFloatContainer = ({ children }) => (
  <Container fixed sx={{}}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "100vh" }}
    >
      <Grid item>{children}</Grid>
    </Grid>
  </Container>
);

export default SFPageFloatContainer;
